import React, { memo } from 'react';
import { connect } from 'react-redux';

import FlashMessage from 'components/FlashMessage';
import { removeFlashMessage as removeFlashMessageRaw } from 'store/main/ducks/flashMessages';

type Props = {
  flashMessages: Array<FlashMessageType>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeFlashMessage: (...args: Array<any>) => any;
};
const FlashMessageContainer = memo<Props>(
  ({ flashMessages, removeFlashMessage }: Props) => (
    <div id="flash-message-container">
      {flashMessages.map((flashMessage) => (
        <FlashMessage
          key={flashMessage.id}
          flashMessage={flashMessage}
          removeMessage={() => removeFlashMessage(flashMessage.id)}
        />
      ))}
    </div>
  )
);

const mapStateToProps = ({ flashMessages }) => ({
  flashMessages,
});

// @ts-expect-error ts-migrate(2558) FIXME: Expected 5 type arguments, but got 6.
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/ban-types
export default connect<Props, {}, _, _, _, _>(mapStateToProps, {
  removeFlashMessage: removeFlashMessageRaw,
})(FlashMessageContainer);
